import React from 'react';

const DashboardCardBody = ({ children }) => <div className="dashboardCard-body">{children}</div>;

export default DashboardCardBody;
